import { BaseMenuSection } from '.';
import { createElement, Fragment, ReactNode } from 'react';
import { createUseHtmlId } from '../../../hooks/useHtmlId';

import cx from 'classnames';
import cn from './MenuListSection.css.json';
import './MenuListSection.css';

interface MenuSectionProps {
  children?: ReactNode;
  section: BaseMenuSection;
  index: number;
  disabled?: boolean;
  onSubmenuClosed: () => void;
}

const useTitleId = createUseHtmlId('Menu-group');

/**
 * @internal
 */
export const MenuListSection = (props: MenuSectionProps) => {
  const titleId = useTitleId();
  const isFirst = props.index === 0;
  const hasTitle = !!props.section.title;
  const titleCls = cx(
    cn.title,
    isFirst ? undefined : cn.separated,
    props.disabled && cn.titleDisabled
  );

  const divider = <div className={cn.divider} onMouseEnter={props.onSubmenuClosed} />;
  return hasTitle ? (
    <div key={props.index} role="group" aria-labelledby={titleId}>
      <div id={titleId} className={titleCls} onMouseEnter={props.onSubmenuClosed}>
        {props.section.title}
      </div>
      {divider}
      {props.children}
    </div>
  ) : (
    <Fragment key={props.index}>
      {!isFirst && divider}
      {props.children}
    </Fragment>
  );
};
